module.exports = __webpack_public_path__ + "img/service_progress_1.10efbfb8.png";